/**
 * Generated bundle index. Do not edit.
 */

export {PositionStyle,paginateSettings,NgSearchInterface,NgSearchTypesEnum,NgPureDataTableEventService,NgPureDatatableModule} from './public_api';

export {NgPaginateComponent as ɵb} from './src/app/ng-pure-datatable/ng-paginate/ng-paginate.component';
export {NgPaginateService as ɵc} from './src/app/ng-pure-datatable/ng-paginate/ng-paginate.service';
export {NgPureDatatableComponent as ɵa} from './src/app/ng-pure-datatable/ng-pure-datatable.component';
export {NgSearchComponent as ɵd} from './src/app/ng-pure-datatable/ng-search/ng-search.component';
export {NgSearchService as ɵe} from './src/app/ng-pure-datatable/ng-search/ng-search.service';